module.exports = __webpack_public_path__ + "img/faqs.929d7334.svg";